module.exports = __webpack_public_path__ + "img/background.dca0e881.png";